import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getKolOptions } from "../../../apis/optionKol";
import {
	getPatients,
	addPatients,
	hearAboutUs,
	modifyPatientGI,
} from "../../../apis/patients";
import { LANGUAGES, MARITAL_STATUS, RACES } from "../../../constants";
import { missingPopup } from "../../../helperFunctions/missingFieldToast";
import { toastify } from "../../../helperFunctions/toastify";
import { setPatientData } from "../../../redux/slices/patientSlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ClickAwayListener from "@mui/base/ClickAwayListener";
import { Popover } from "antd";
import { PREFERRED_CONTACTS } from "../../../constants";
import { Country } from "country-state-city";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { setForm } from "../../../redux/slices/StaffFormsSlices";
import { authorizedRequests } from "../../../axios/axios-config";
import SelectComponent from "../../SharedComponents/SelectComponent";
import { getQuestionnaireByPatientId } from "../../../apis/questionnaire";

export default function TabGeneralInfo({ setPage }) {
	const dispatch = useDispatch();

	const patientData = useSelector((state) => state.patientData.value);

	const [kolOptions, setKolOptions] = useState([]);
	const [gender, setGender] = useState();
	const [isActive, setIsActive] = useState();
	const [name, setName] = useState("");
	// const [nationalID, setNationalID] = useState();
	const [occupation, setOccupation] = useState("");
	const [selectedMaritalStatus, setSelectedMaritalStatus] = useState();
	const [selectedRace, setSelectedRace] = useState();
	const [selectedLanguage, setSelectedLanguage] = useState();
	const [selectedKol, setSelectedKol] = useState();
	const [dob, setDob] = useState();
	const [source, setSource] = useState();
	const [isMember, setIsMember] = useState(false);
	const [receiveMarkInfo, setReceiveMarkInfo] = useState(false);
	const [patients, setPatients] = useState([]);
	const [selectedPatient, setSelectedPatient] = useState();
	const [description, setDescription] = useState("");
	const [tagText, setTagText] = useState("");
	const [hashtags, setHashtags] = useState([]);
	const [hearingOptions, setHearingOptions] = useState([]);
	const [maritalStatus, setMaritalStatus] = useState(MARITAL_STATUS);
	const [races, setRaces] = useState(RACES);
	const [languages, setLanguages] = useState(LANGUAGES);

	const [country, setCountry] = useState();
	const [countries, setCountries] = useState();
	const [email, setEmail] = useState("");
	const [contactNo, setContactNo] = useState("");
	const [preferredContact, setPreferredContact] = useState();
	const [contactOptions, setContactOptions] = useState(PREFERRED_CONTACTS);
	const [address, setAddress] = useState("");
	const [postalCode, setPostalCode] = useState("");
	const [showDate, setShowDate] = useState(false);

	const contactRegex = new RegExp("^[0-9]+[0-9]*$");

	const location = useLocation();
	const navigate = useNavigate();

	const [status, setStatus] = useState([
		{ name: "Active", value: true },
		{ name: "InActive", value: false },
	]);

	const populatePatients = async () => {
		const response = await getPatients();
		setPatients(response);
	};

	const populateHearAboutUs = async () => {
		const response = await hearAboutUs();
		setHearingOptions(response);
	};

	const populateKolOptions = async () => {
		const response = await getKolOptions();
		if (response?.status !== "Fail") {
			setKolOptions(response);
		}
	};

	const editPatient = async () => {
		if (!name) {
			missingPopup("Name");
		}
		// else if (!nationalID) {
		//   missingPopup("National ID");
		// }
		// else if (!dob) {
		//   missingPopup("Date of Birth");
		// }
		else if (!gender) {
			missingPopup("Gender");
		} else if (isActive === undefined) {
			missingPopup("Is Active key");
		} else {
			let apiData = {
				fullName: name,
				maritalStatus: selectedMaritalStatus,
				// nationID: nationalID,
				race: selectedRace,

				email,
				contactNo,
				address,
				preferredContact,
				country,
				postalCode,
				dob,
				occupation,
				gender,
				language: selectedLanguage,
				kol: selectedKol,
				hearAboutUs: source,
				recommendFrom: selectedPatient,
				description,
				hashtag: hashtags,
			};
			const response = await modifyPatientGI(
				patientData?._id,
				apiData,
				isActive,
				isMember,
				receiveMarkInfo,
			);
			if (response.status !== "Fail") {
				toastify("Patient added successfully!", "success");
				dispatch(setPatientData(response));
				// setPage("emergencyContact");
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const save = async () => {
		// console.log(location?.state.isFromAppointment);
		if (!name) {
			missingPopup("Name");
		}
		// else if (!nationalID) {
		//   missingPopup("National ID");
		// }
		// else if (!dob) {
		//   missingPopup("Date of Birth");
		// }
		else if (!gender) {
			missingPopup("Gender");
		} else if (isActive === undefined) {
			missingPopup("Status");
		} else {
			let apiData = {
				fullName: name,
				maritalStatus: selectedMaritalStatus,
				// nationID: nationalID,
				race: selectedRace,
				email,
				contactNo,
				address,
				preferredContact,
				country,
				postalCode,
				dob,
				occupation,
				gender,
				language: selectedLanguage,
				kol: selectedKol,
				hearAboutUs: source,
				recommendFrom: selectedPatient,
				description,
				hashtag: hashtags,
			};
			const response = await addPatients(
				apiData,
				isActive,
				isMember,
				receiveMarkInfo,
			);
			if (response?.status !== "Fail") {
				toastify("Patient added successfully!", "success");
				if (location?.state?.isFromAppointment) {
					dispatch(
						setForm({
							parent: "appointmentForm",
							child: "patient",
							value: response._id,
						}),
					);
					navigate(-1);
					return;
				} else {
					dispatch(setPatientData(response));

					// setPage("emergencyContact");
				}
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const setOtherInfo = () => {
		setPostalCode(patientData?.patientProfile?.postalCode);
		setAddress(patientData?.patientProfile?.address);
		setContactNo(patientData?.patientProfile?.contactNo);
		setEmail(patientData?.patientProfile?.email);
		if (
			// patientData?.patientProfile?.city &&
			patientData?.patientProfile?.country
		) {
			// setCityCountry();
			const myCountry = Country.getCountryByCode(
				patientData?.patientProfile?.country?.isoCode,
			);
			// let _cities = City.getCitiesOfCountry(
			//   patientData?.patientProfile?.country?.isoCode
			// );
			const allCountries = Country.getAllCountries();

			allCountries.forEach(function (item, i) {
				if (item.name === myCountry?.name) {
					allCountries.splice(i, 1);
					allCountries.unshift(item);
				}
			});
		}

		let _prefContact = [...contactOptions];
		_prefContact.forEach(function (item, i) {
			if (item === patientData?.patientProfile?.preferredContact) {
				_prefContact.splice(i, 1);
				_prefContact.unshift(item);
			}
		});
		setPreferredContact(_prefContact[0]);
		setContactOptions(_prefContact);
	};

	const populateData = async () => {
		const response = await Promise.all([
			getPatients(),
			hearAboutUs(),
			getKolOptions(),
		]);
		const resPatient = response[0];
		const resAboutUs = response[1];
		const resKolOptions = response[2];

		setName(patientData?.patientProfile?.fullName);
		// setNationalID(patientData?.patientProfile?.nationID);
		setOccupation(patientData?.patientProfile?.occupation);
		setDescription(patientData?.patientProfile?.description);
		setGender(patientData?.patientProfile?.gender);
		setIsMember(patientData?.isMember);
		setReceiveMarkInfo(patientData?.receiveMarketingInfo);
		setHashtags(patientData?.patientProfile?.hashtag);
		setCountry(patientData?.patientProfile?.country);
		setOtherInfo();
		setDob(
		  patientData?.patientProfile?.dob &&
		    patientData?.patientProfile?.dob !== ""
		    ? new Date(patientData?.patientProfile?.dob)
		    : null
		);

		// setCityCountry();

		if (patientData?.patientProfile?.maritalStatus) {
			let _maritalStatus = [...maritalStatus];
			_maritalStatus.forEach(function (item, i) {
				if (item === patientData?.patientProfile?.maritalStatus) {
					_maritalStatus.splice(i, 1);
					_maritalStatus.unshift(item);
				}
			});
			setMaritalStatus(_maritalStatus);
			setSelectedMaritalStatus(_maritalStatus[0]);
		}

		let _races = [...races];
		_races.forEach(function (item, i) {
			if (item === patientData?.patientProfile?.race) {
				_races.splice(i, 1);
				_races.unshift(item);
			}
		});
		setRaces(_races);
		setSelectedRace(_races[0]);

		if (patientData?.patientProfile?.language) {
			let _languages = [...languages];
			_languages.forEach(function (item, i) {
				if (item === patientData?.patientProfile?.language) {
					_languages.splice(i, 1);
					_languages.unshift(item);
				}
			});
			setLanguages(_languages);
			setSelectedLanguage(_languages[0]);
		}

		let _status = [...status];
		_status.forEach(function (item, i) {
			if (item?.value === patientData?.isActive) {
				_status.splice(i, 1);
				_status.unshift(item);
			}
		});
		setStatus(_status);
		setIsActive(_status[0].value);

		let _kolOptions = [...resKolOptions];
		// _kolOptions.forEach(function (item, i) {
		// 	if (item?._id === patientData?.patientProfile?.kol) {
		// 		_kolOptions.splice(i, 1);
		// 		_kolOptions.unshift(item);
		// 	}
		// });
		setKolOptions(_kolOptions);
		setSelectedKol(patientData?.patientProfile?.kol);

		if (patientData?.patientProfile?.hearAboutUs) {
			let _hearingOptions = [...resAboutUs];
			_hearingOptions.forEach(function (item, i) {
				if (item?._id === patientData?.patientProfile?.hearAboutUs) {
					_hearingOptions.splice(i, 1);
					_hearingOptions.unshift(item);
				}
			});
			setHearingOptions(_hearingOptions);
			setSource(_hearingOptions[0]._id);
		} else {
			setHearingOptions(resAboutUs);
		}

		let _patients = [...resPatient];
		// _patients.forEach(function (item, i) {
		// 	if (item?._id === patientData?.patientProfile?.recommendFrom) {
		// 		_patients.splice(i, 1);
		// 		_patients.unshift(item);
		// 	}
		// });
		setPatients(_patients);
		setSelectedPatient(patientData?.patientProfile?.recommendFrom);
		// getQuestionnaireData();
	};

	const openQuestionnaire = () => {
		window.open(`/questions/${patientData._id}`, "_blank").focus();
	};

	const getQuestionnaireData = async () => {
		const { result, error } = await getQuestionnaireByPatientId(
			patientData._id,
		);

		if (result) {
			result?.data?.questionData?.forEach((o) => {
				if (o?.question?.linkedTo == "fullName" && !name)
					setName(o.textAnswer);
				else if (o?.question?.linkedTo == "occupation" && !occupation) {
					setOccupation(o.textAnswer);
				} else if (o?.question?.linkedTo == "email" && !email)
					setEmail(o.textAnswer);
				else if (o?.question?.linkedTo == "contactNo" && !contactNo)
					setContactNo(o.textAnswer);
				else if (o?.question?.linkedTo == "postalCode" && !postalCode)
					setPostalCode(o.textAnswer);
				else if (o?.question?.linkedTo == "address" && !address)
					setAddress(o.textAnswer);
				else if (o?.question?.linkedTo == "description" && !description)
					setDescription(o.textAnswer);
			});
		}
	};
	const copy = () => {
		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(
				`${process.env.REACT_APP_OWN_URI}questions/${patientData._id}`,
			);
		} else {
			const textArea = document.createElement("textarea");
			textArea.value = `${process.env.REACT_APP_OWN_URI}questions/${patientData._id}`;
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			try {
				document.execCommand("copy");
			} catch (err) {
				console.error("Unable to copy to clipboard", err);
			}
			document.body.removeChild(textArea);
		}
	};

	// const setCityCountry = async () => {
	//   const myCountry = Country.getCountryByCode(
	//     patientData?.patientProfile?.country?.isoCode
	//   );
	//   // let _cities = City.getCitiesOfCountry(
	//   //   patientData?.patientProfile?.country?.isoCode
	//   // );
	//   const allCountries = Country.getAllCountries()

	//   allCountries.forEach(function (item, i) {
	//     if (item.name === myCountry?.name) {
	//       allCountries.splice(i, 1);
	//       allCountries.unshift(item);
	//     }
	//   });

	//   // _cities.forEach(function (item, i) {
	//   //   if (
	//   //     item.name === patientData?.patientProfile?.city ||
	//   //     item.name.toLowerCase === patientData?.patientProfile?.city
	//   //   ) {
	//   //     _cities.splice(i, 1);
	//   //     _cities.unshift(item);
	//   //   }
	//   // });

	//   setCountries(allCountries);
	//   setCountry(allCountries[0]);
	//   // setCities(_cities);
	//   // setCity(_cities[0]);
	// };

	useEffect(() => {
		if (patientData) {
			populateData();
		} else {
			populatePatients();
			populateHearAboutUs();
			populateKolOptions();
		}
		setCountries(Country.getAllCountries());
	}, []);

	useEffect(() => {
		if (!patientData?._id) {
			return;
		}
		// ()();
	}, [patientData?._id]);
	return (
		<div>
			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Full Name *</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="Write..."
							maxLength={30}
						/>
					</InputGroup>
				</Form.Group>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">
						Marital Status
					</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={selectedMaritalStatus}
						onChange={(e) => {
							setSelectedMaritalStatus(e.value);
						}}
						options={
							maritalStatus?.length > 0
								? [
										...maritalStatus?.map((e) => {
											return {
												value: e,
												label: e,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						onChange={(e) => {
							setSelectedMaritalStatus(e.target.value);
						}}
					>
						{!patientData?.patientProfile?.maritalStatus && (
							<option value={""}>Select</option>
						)}
						{maritalStatus?.map((e) => (
							<option value={e}>{e}</option>
						))}
					</select> */}
				</Form.Group>
			</div>

			<div className="d-flex">
				{/* <Form.Group className="col-5 mt-3">
          <Form.Label className="headings2">National ID *</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              value={nationalID}
              maxLength={30}
              onChange={(e) => setNationalID(e.target.value)}
              placeholder="Write..."
            />
          </InputGroup>
        </Form.Group> */}

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Occupation</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							value={occupation}
							onChange={(e) => setOccupation(e.target.value)}
							placeholder="Write..."
							maxLength={30}
						/>
					</InputGroup>
				</Form.Group>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Race</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={selectedRace}
						onChange={(e) => {
							setSelectedRace(e.value);
						}}
						options={
							races?.length > 0
								? [
										...races?.map((e) => {
											return {
												value: e,
												label: e,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						onChange={(e) => {
							setSelectedRace(e.target.value);
						}}
					>
						{!patientData?.patientProfile?.race && (
							<option value={""}>Select</option>
						)}
						{races?.map((e) => (
							<option value={e}>{e}</option>
						))}
					</select> */}
				</Form.Group>
			</div>

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Email</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							placeholder="Write..."
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							// maxLength={30}
						/>
					</InputGroup>
				</Form.Group>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Postal Code</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							placeholder="Write..."
							value={postalCode}
							onChange={(e) => setPostalCode(e.target.value)}
							maxLength={10}
						/>
					</InputGroup>
				</Form.Group>

				{/* <Form.Group className="col-5 mt-3">
          <Form.Label className="headings2">City</Form.Label>
          <select
            className="form-select mb-3"
            onChange={(e) => {
              let val = e.target.value;
              if (val === "") {
                setCity();
              } else {
                setCity(JSON.parse(e.target.value));
              }
            }}
          >
            {!patientData?.patientProfile?.city && (
              <option value={""}>Select</option>
            )}
            {cities?.map((e, id) => (
              <option value={JSON.stringify(e)}>{e.name}</option>
            ))}
          </select>
        </Form.Group> */}
			</div>

			<div className="d-flex flex-row">
				<div className="col-5">
					<Form.Group className=" mt-3">
						<Form.Label className="headings2">
							Contact No
						</Form.Label>
						<InputGroup className="mb-3">
							<Form.Control
								placeholder="Write..."
								value={contactNo}
								onChange={(e) => {
									if (
										contactRegex.test(e.target.value) ||
										e.target.value === ""
									) {
										setContactNo(e.target.value);
									}
								}}
								maxLength={20}
							/>
						</InputGroup>
					</Form.Group>

					<ClickAwayListener onClickAway={() => setShowDate(false)}>
						<div>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									value={dob}
									onChange={(newValue) => {
										setDob(newValue?.$d);
										setShowDate(false);
									}}
									open={showDate}
									maxDate={new Date()}
									renderInput={({ inputRef, inputProps, InputProps }) => (
										<Form.Group className="mt-3">
											<Form.Label className="headings2">Date of Birth</Form.Label>
											<InputGroup className="mb-3 d-flex pe-3 align-items-center">
												<Form.Control
													ref={inputRef}
													// {...inputProps}
													value={
														dob ? new Date(dob).toLocaleDateString() : null
													}
													onClick={() => setShowDate(!showDate)}
													readOnly
													placeholder="Select"
												/>
												<div onClick={() => setShowDate(!showDate)}>
													{InputProps?.endAdornment}
												</div>
											</InputGroup>
										</Form.Group>
									)}
								/>
							</LocalizationProvider>
						</div>
					</ClickAwayListener>

					<Form.Group className=" mt-3">
						<Form.Label className="headings2">
							Preferred Contact
						</Form.Label>
						<SelectComponent
							singleSelect
							searchEnabled
							selectedValue={preferredContact ?? null}
							onChange={(e) => {
								let val = e.value;
								if (val === "") {
									setPreferredContact();
								} else {
									setPreferredContact(e.value);
								}
							}}
							options={
								contactOptions?.length > 0
									? [
											...contactOptions?.map((e) => {
												return {
													value: e,
													label: e,
												};
											}),
									  ]
									: []
							}
						/>
						{/* <select
							className="form-select mb-3"
							aria-label="Default select example"
							onChange={(e) => {
								let val = e.target.value;
								if (val === "") {
									setPreferredContact();
								} else {
									setPreferredContact(e.target.value);
								}
							}}
						>
							{!patientData?.patientProfile?.preferredContact && (
								<option value={""}>Select</option>
							)}
							{contactOptions.map((e) => (
								<option value={e}>{e}</option>
							))}
						</select> */}
					</Form.Group>
				</div>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Address</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							as="textarea"
							placeholder="Write..."
							style={{ resize: "none" }}
							className="larger-text-area"
							value={address}
							maxLength={50}
							onChange={(e) => setAddress(e.target.value)}
						/>
					</InputGroup>
				</Form.Group>
			</div>

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2 d-flex">
						Country
					</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={country ? JSON.stringify(country) : null}
						onChange={(e) => {
							let val = e.value;
							if (val === "") {
								setCountry();
							} else {
								setCountry(JSON.parse(val));
							}
						}}
						options={
							countries?.length > 0
								? [
										...countries?.map((e) => {
											return {
												value: JSON.stringify({
													name: e.name,
													isoCode: e.isoCode,
												}),
												label: e.name,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						onChange={(e) => {
							// if (country) {
							//   let newCities = City.getCitiesOfCountry(country.isoCode);
							//   setCities(newCities);
							// }
							let val = e.target.value;
							if (val === "") {
								setCountry();
								// setCity();
								// setCities([]);
							} else {
								setCountry(JSON.parse(val));
								// let newCities = City.getCitiesOfCountry(
								//   JSON.parse(val).isoCode
								// );
								// setCities(newCities);
								// setCity(newCities[0]);
							}
						}}
					>
						{!patientData?.patientProfile?.country && (
							<option value={""}>Select</option>
						)}
						{countries?.map((e) => (
							<option value={JSON.stringify(e)}>{e.name}</option>
						))}
					</select> */}
				</Form.Group>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Language</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={selectedLanguage ?? null}
						onChange={(e) => {
							let val = e.value;
							if (val === "") {
								setSelectedLanguage();
							} else {
								setSelectedLanguage(e.value);
							}
						}}
						options={
							languages?.length > 0
								? [
										...languages?.map((e) => {
											return {
												value: e,
												label: e,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						aria-label="Default select example"
						onChange={(e) => {
							let val = e.target.value;
							if (val === "") {
								setSelectedLanguage();
							} else {
								setSelectedLanguage(e.target.value);
							}
						}}
					>
						{!patientData?.patientProfile?.language && (
							<option value={""}>Select</option>
						)}
						{languages?.map((e) => (
							<option value={e}>{e}</option>
						))}
					</select> */}
				</Form.Group>
			</div>

			{/* <Button className="addItem" onClick={savePatient}>
        Save
      </Button> */}

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2 d-flex">
						Gender *
					</Form.Label>
					<Form.Check
						inline
						label="Male"
						type={"radio"}
						onClick={() => setGender("Male")}
						checked={gender === "Male"}
					/>
					<Form.Check
						inline
						label="Female"
						type={"radio"}
						onClick={() => setGender("Female")}
						checked={gender === "Female"}
					/>
				</Form.Group>

				<span className="col-1" />

				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">KOL/Channel</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={selectedKol ?? null}
						onChange={(e) => {
							let val = e.value;
							if (val === "") {
								setSelectedKol();
							} else {
								setSelectedKol(e.value);
							}
						}}
						options={
							kolOptions?.length > 0
								? [
										...kolOptions?.map((e) => {
											return {
												value: e._id,
												label: e.name,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						aria-label="Default select example"
						onChange={(e) => {
							let val = e.target.value;
							if (val === "") {
								setSelectedKol();
							} else {
								setSelectedKol(e.target.value);
							}
						}}
					>
						{!patientData?.patientProfile?.kol && (
							<option value={""}>Select</option>
						)}
						{kolOptions?.map((e) => (
							<option value={e._id}>{e.name}</option>
						))}
					</select> */}
				</Form.Group>
			</div>

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">Status *</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={isActive}
						onChange={(e) => {
							let val = e.value;
							setIsActive(val);

							// if (val == "" || val == null) {
							// 	setIsActive();
							// } else {
							// }
						}}
						options={
							status?.length > 0
								? [
										...status?.map((e) => {
											return {
												value: e.value,
												label: e.name,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						aria-label="Default select example"
						onChange={(e) => {
							let val = e.target.value === "true" ? true : false;
							if (val === "") {
								setIsActive();
							} else {
								setIsActive(val);
							}
						}}
					>
						{!patientData && <option value={""}>Select</option>}
						{status?.map((e) => (
							<option value={e.value}>{e.name}</option>
						))}
					</select> */}
				</Form.Group>

				<span className="col-1" />

				<Form>
					<div className="mt-4">
						<Form.Check
							type={"checkbox"}
							label="Member"
							onClick={() => setIsMember(!isMember)}
							checked={isMember === true}
						/>
						<Form.Check
							type={"checkbox"}
							label="I agree to receive marketing information"
							onClick={() => setReceiveMarkInfo(!receiveMarkInfo)}
							checked={receiveMarkInfo === true}
						/>
					</div>
				</Form>
			</div>

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">
						How Did You Hear About Us?
					</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={source ?? null}
						onChange={(e) => {
							let val = e.value;
							if (val === "") {
								setSource();
							} else {
								setSource(e.value);
							}
						}}
						options={
							hearingOptions?.length > 0
								? [
										...hearingOptions?.map((e) => {
											return {
												value: e._id,
												label: e.name,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						aria-label="Default select example"
						onChange={(e) => {
							let val = e.target.value;
							if (val === "") {
								setSource();
							} else {
								setSource(e.target.value);
							}
						}}
					>
						{!patientData?.patientProfile?.hearAboutUs && (
							<option value={""}>Select</option>
						)}
						{hearingOptions?.map((e) => (
							<option value={e._id}>{e.name}</option>
						))}
					</select> */}
				</Form.Group>

				<span className="col-1" />
				
				{
					patientData && (
						<React.Fragment>
							<Popover
								className="popper"
								content={<div>Copied to Clipboard!</div>}
								trigger="click"
							>
								<div
									onClick={copy}
									className="cursor-pointer copy-icon mt-4 me-3"
								>
									<i class="fa-regular fa-copy"></i>
								</div>
							</Popover>

							<button
								className="questionnaire-button mt-4"
								onClick={openQuestionnaire}
							>
								Questionnaire
							</button>
						</React.Fragment>
					)
				}
			</div>

			<div className="d-flex">
				<Form.Group className="col-5 mt-3">
					<Form.Label className="headings2">
						Recommend From
					</Form.Label>
					<SelectComponent
						singleSelect
						searchEnabled
						selectedValue={selectedPatient ?? null}
						onChange={(e) => {
							let val = e.value;
							if (val === "") {
								setSelectedPatient();
							} else {
								setSelectedPatient(e.value);
							}
						}}
						options={
							patients.length > 0
								? [
										...patients?.map((e) => {
											return {
												value: e._id,
												label: e.patientProfile
													.fullName,
											};
										}),
								  ]
								: []
						}
					/>
					{/* <select
						className="form-select mb-3"
						aria-label="Default select example"
						onChange={(e) => {
							let val = e.target.value;
							if (val === "") {
								setSelectedPatient();
							} else {
								setSelectedPatient(e.target.value);
							}
						}}
					>
						{!patientData?.patientProfile?.recommendFrom && (
							<option value={""}>Select</option>
						)}
						{patients?.map((e) => (
							<option value={e._id}>
								{e.patientProfile.fullName}
							</option>
						))}
					</select> */}
				</Form.Group>

				<span className="col-1" />
			</div>

			<Form.Group className="mt-3">
				<Form.Label className="headings2">Description</Form.Label>
				<InputGroup className="mb-3">
					<Form.Control
						as="textarea"
						placeholder="Write..."
						style={{ resize: "none" }}
						className="large-text-area"
						value={description}
						maxLength={50}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</InputGroup>
			</Form.Group>

			<Form.Group className="col-5 mt-3">
				<Form.Label className="headings2">Input Hashtag</Form.Label>
				<InputGroup className="mb-3 p-0">
					<Form.Control
						placeholder="Write..."
						value={tagText}
						maxLength={15}
						onChange={(e) => setTagText(e.target.value)}
					/>
					<Button
						size="sm"
						className="add-button"
						onClick={() => {
							if (tagText && tagText !== "") {
								setHashtags((old) => [...old, tagText]);
								setTagText("");
							}
						}}
					>
						Add
					</Button>
				</InputGroup>
				<div className="d-flex mb-3 flex-wrap">
					{hashtags?.map((hash) => (
						<span
							className="multi-select"
							onClick={() => {
								let arr = [...hashtags].filter(
									(e) => !e.includes(hash),
								);
								setHashtags(arr);
							}}
						>
							{hash}
							<i
								class="fa-solid fa-xmark ms-3"
								style={{ color: "red" }}
							></i>
						</span>
					))}
				</div>
			</Form.Group>

			<Button
				className="addItem"
				onClick={() => {
					if (patientData) {
						editPatient();
					} else {
						save();
					}
				}}
			>
				Save
			</Button>
		</div>
	);
}
